import type { AppType } from "@savi/api/src/server.js";
import { hc } from "hono/client";

/**
 * Same-origin in production, proxied by Vite in dev. Types flow from the
 * Hono route definitions with no code generation step.
 */
export const api = hc<AppType>("/");

export type PublicUser = { id: string; email: string; displayName: string };

export async function login(email: string, password: string) {
  const res = await api.api.auth.login.$post({ json: { email, password } });
  if (res.ok) return { ok: true as const };
  if (res.status === 401) return { ok: false as const, error: "Email or password is incorrect" };
  if (res.status === 400) return { ok: false as const, error: "Enter a valid email and password" };
  return { ok: false as const, error: "Something went wrong. Try again." };
}

export async function logout(): Promise<void> {
  await api.api.auth.logout.$post();
}

export async function fetchMe(): Promise<PublicUser | null> {
  const res = await api.api.auth.me.$get();
  if (!res.ok) return null;
  const body = (await res.json()) as { user: PublicUser };
  return body.user;
}
